import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const displayTime = (value) =>
  value && moment(value).isValid() ? moment(value).format('HH:mm') : '—';

const fileLinks = (files) => {
  if (!files?.length) {
    return '—';
  }
  return (
    <>
      {files.map((file, index) => (
        <React.Fragment key={file.id || index}>
          {index > 0 && ', '}
          <a href={file.url} target='_blank' rel='noreferrer'>
            {file.name || file.file_name || file.url}
          </a>
        </React.Fragment>
      ))}
    </>
  );
};

export const getOperationViewSections = (
  t,
  item,
  { facilityTypes, statuses } = {},
) => {
  if (!item?.id) {
    return [];
  }

  const additional = item.facility_operation_additional || {};

  return [
    {
      title: t('Informazioni Generali'),
      fields: [
        {
          text: t('Outlet Village'),
          value: display(
            item['shopping_centers.title'] ||
              item.company?.shopping_center?.title,
          ),
        },
        {
          text: t('Insegna'),
          value: display(item['companies.title'] || item.company?.title),
        },
        {
          text: t('Categoria richiesta'),
          value: display(
            facilityTypes?.[item.facility_type] || item.facility_type,
          ),
        },
        {
          text: t('Data richiesta'),
          value: display(item.created_at),
        },
        { text: t('Data dal'), value: displayDate(item.date_from) },
        { text: t('Orario dalle'), value: displayTime(item.time_from) },
        { text: t('Data al'), value: displayDate(item.date_to) },
        { text: t('Orario alle'), value: displayTime(item.time_to) },
        { text: t('Descrizione'), value: display(item.description) },
        {
          text: t('Stato'),
          value: display(statuses?.[item.status] || item.status),
        },
      ],
    },
    {
      title: t('Allegato'),
      fields: [{ text: t('File'), value: fileLinks(item.files) }],
    },
    {
      title: t('DATI FORNITORI ESTERNI'),
      fields: [
        {
          text: t('Nome azienda fornitore'),
          value: display(additional.company_name),
        },
        {
          text: t('Nr addetti'),
          value: display(additional.worker_quantity),
        },
        {
          text: t('Nominativo di contatto'),
          value: display(additional.company_contract_person),
        },
        {
          text: t('Telefono di contatto'),
          value: display(additional.company_phone),
        },
      ],
    },
    {
      title: t('ACCESSO AUTOMEZZI'),
      fields: [
        {
          text: t('Tipologia automezzo (modello)'),
          value: display(additional.car_type),
        },
        {
          text: t('Portata automezzo ( portata quintali x camion)'),
          value: display(additional.center_capacity),
        },
        { text: t('Targa'), value: display(additional.vehicle_number) },
        { text: t('Conducente'), value: display(additional.driver) },
        {
          text: t('Telefono di contatto'),
          value: display(additional.driver_contact),
        },
      ],
    },
  ];
};
